// extracted by mini-css-extract-plugin
export default {"icon":"eyeIcon_icon__JxlNc"};